export default __webpack_public_path__ + "static/media/heartIcon_active_red.2738ae06.svg";